import React from 'react'
import styled from 'styled-components'

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  .switch {
    position: relative;
    float: left;
    margin: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .switch-checkbox {
    display: none;
  }
  .switch-label {
    display: block;
    overflow: hidden;
    width: 92px;
    height: 32px;
    cursor: pointer;
    border-radius: 22px;
    background-color: #E6DFD4;
    transition: all 0.1s ease-in 0s;
    padding-right: 10px;
  }

  .switch-inner {
    display: block;
    width: 200%;
    height: 32px;
    line-height: 32px;
    transition: margin 0.1s ease-in 0s;
    text-align: right;
    color: ${({ theme }) => theme.bsText22};
    font-size: 13px;
    font-family: 'Roboto-Bold';
  }

  .switch-inner::before,
  .switch-inner::after {
    display: block;
    float: right;
    width: 50%;
    height: 32px;
    padding: 0;
    line-height: 32px;
    font-size: 14px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
  }

  .switch-inner::after {
    content: '';
    padding-left: 5px;
    background-color: #6177aa;
    color: #ffffff;
    margin-top: 10px;
  }

  .switch-inner::before {
    content: '';
    padding-right: 5px;
    background-color: #E6DFD4;
    color: #999999;
    text-align: right;
  }

  .switch-switch {
    position: relative;
    display: block;
    width: 24px;
    height: 24px;
    margin: 1px;
    background: #ffffff;
    top: -29px;
    bottom: 0;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.06);
    border-radius: 18px;
    transition: all 0.1s ease-in 0s;
  }

  .switch-checkbox:checked + .switch-label .switch-inner {
    margin-left: 10px;
    text-align: left;
    color: white;
  }

  .switch-checkbox:checked + .switch-label .switch-switch {
    margin-left: 65px;
  }
  .switch-checkbox:checked + .switch-label {
    background: linear-gradient(285.72deg, #FFD600 -21.15%, #FF7A00 60.61%);
  }
  #toggle-button{
      display: none;
  }
  .button-label{
      position: relative;
      display: inline-block;
      width: 80px;
      background-color: #ccc;
      border: 1px solid #ccc;
      border-radius: 30px;
      cursor: pointer;
  }
  .circle{
      position: absolute;
      top: 0;
      left: 0;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #fff;
      transition: all 0.1s ease-in 0s;
  }
  .button-label .text {
      line-height: 30px;
      font-size: 18px;
      /*
      用来阻止页面文字被选中，出现蓝色
      可以将下面两行代码注释掉来查看区别
      */
      -webkit-user-select: none;
      user-select: none;
  }
  .on {
      color: #fff;
      display: none;
      text-indent: 10px;
  }
  .off {
      color: #fff;
      display: inline-block;
      text-indent: 53px;
  }
  .button-label .circle{
      left: 0;
      transition: all 0.1s ease-in 0s;

      /* transition: all 0.4s;transition过度，时间为0.4秒 */
  }
  #toggle-button:checked + label.button-label .circle{
      left: 50px;
  }
  #toggle-button:checked + label.button-label .on{
      display: inline-block;
  }
  #toggle-button:checked + label.button-label .off{
      display: none;
  }
  #toggle-button:checked + label.button-label{
      background-color: rgb(43, 180, 77);
  }
`

export default function Switch({
  checked,
  id,
  toggleChecked,
}: {
  checked: boolean
  id: string
  toggleChecked: (id: any) => void
}) {
  return (
    <SwitchWrapper className="switch">
      {/* <input 
        type="checkbox" 
        id="toggle-button" 
        checked={checked}
        onChange={() => toggleChecked(id)}
      />
      <label htmlFor="toggle-button" className="button-label">
          <span className="circle"></span>
          <span className="text on">开</span>
          <span className="text off">关</span>
      </label> */}
      <input
        className="switch-checkbox"
        id={`switch${id}`}
        type="checkbox"
        checked={checked}
        onChange={() => toggleChecked(id)}
      />
      <label className="switch-label" htmlFor={`switch${id}`}>
        <span className="switch-inner">{checked ? 'Review' : 'Pending'}</span>
        <span className="switch-switch"></span>
      </label>
    </SwitchWrapper>
  )
}
